
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChoose from './components/WhyChoose';
import Process from './components/Process';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Industries from './components/Industries';
import Partnership from './components/Partnership';
import PartnershipForm from './components/PartnershipForm';
import Contact from './components/Contact';
import CTA from './components/CTA';
import SEOHead from '../../components/feature/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://zjfitservices.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'ZJF IT Services LLC',
    description: 'Professional IT deployment and infrastructure support specializing in workstation rollouts, network installations, and office IT transitions across New York and nationwide.',
    url: siteUrl,
    telephone: '+19737504968',
    email: 'info@zjfitservices.com',
    logo: 'https://public.files.download.flockmail.com/6581760/2690761113950208_1',
    image: 'https://public.files.download.flockmail.com/6581760/2690761113950208_1',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'New York',
      addressRegion: 'NY',
      addressCountry: 'US',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '40.7128',
      longitude: '-74.0060',
    },
    areaServed: ['New York', 'United States'],
    priceRange: '$$',
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'ZJF IT Services LLC',
    url: siteUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/?s={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What IT deployment services does ZJF IT Services offer?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'ZJF IT Services provides enterprise workstation rollouts, structured cabling, network hardware installations, IMAC services, office IT relocations, and end-user support across New York and nationwide.',
        },
      },
      {
        '@type': 'Question',
        name: 'Where does ZJF IT Services operate?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We are based in New York and provide IT deployment services nationwide across the United States.',
        },
      },
      {
        '@type': 'Question',
        name: 'Does ZJF IT Services work with MSPs?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes. We offer a white-label MSP partnership program, providing reliable field execution for Managed Service Providers and IT integrators nationwide.',
        },
      },
      {
        '@type': 'Question',
        name: 'How quickly does ZJF IT Services respond to inquiries?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We strive to respond to all support and project inquiries within 24 hours.',
        },
      },
    ],
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="New York IT Deployment Services | ZJF IT Services LLC"
        description="ZJF IT Services LLC provides professional IT deployment and infrastructure support across New York and nationwide. Specializing in enterprise workstation rollouts, structured cabling, network hardware installations, and office IT transitions."
        keywords="IT deployment New York, workstation setup NYC, network installation, IMAC services, office IT relocation, structured cabling, enterprise IT rollouts"
        canonical={`${siteUrl}/`}
        jsonLd={homeJsonLd}
      />
      <Hero />
      <About />
      <Services />
      <WhyChoose />
      <Process />
      <Portfolio />
      <Testimonials />
      <Industries />
      <Partnership />
      <PartnershipForm />
      <Contact />
      <CTA />
    </div>
  );
}
